// ======================================================================
// File Name       : BatchImport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, FormControl, Col, Form, Row } from 'react-bootstrap';
import FileUpload from './FileUpload';
import DialogConfirm from '../components/DialogConfirm';
import * as MessageTemplate from '../constants/MessageTemplate';
import { ROOT_URL, SAMPLE_PATH } from '../constants';

/**
 * Batch import Component
 *
 * @class BatchImport
 * @extends {React.Component}
 */
class BatchImport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.onCancel = this.onCancel.bind(this);
    this.onOk = this.onOk.bind(this);
    this.downloadAllFile = this.downloadAllFile.bind(this);
  }

  /**
     * Handle Cancel button
     *
     *
     * @memberof BatchImport
     */
  onCancel() {
    this.setState({ showModal: false });
  }

  /**
     * Handle Ok button
     *
     *
     * @memberof BatchImport
     */
  onOk() {
    this.setState({ showModal: false });
    this.props.handleUpload();
  }

  /**
     * Open Confirm dialog
     *
     * @param {any} mdContent
     * @param {any} mdSize
     *
     * @memberof BatchImport
     */
  openNewDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({
      showModal: true,
    });
  }

  downloadAllFile() {
    let count = 0;
    const intervalDownload = setInterval((fileNames) => {
      const fileName = fileNames[count];
      const link = document.createElement('a');
      link.style.display = 'none';
      document.body.appendChild(link);
      link.href = ROOT_URL.concat(SAMPLE_PATH).concat(fileName);
      link.setAttribute('href', link);
      link.setAttribute('download', fileName);
      link.click();
      document.body.removeChild(link);
      count++;
      if (count === parseInt(fileNames.length, 10)) {
        count = 0;
        clearInterval(intervalDownload);
      }
    }, 1000, this.props.downloadSampleFile);
  }
  render() {
    const { downloadSampleFile } = this.props;
    const downloadSample = (downloadSampleFile && downloadSampleFile.length) ?
                           (<a className="margin-auto" style={{ cursor: 'pointer' }} role="button" tabIndex="0" onClick={this.downloadAllFile} ><u>サンプルダウンロード</u></a>) :
                           (<a role="button" href={'/top'}><u>サンプルダウンロード</u></a>);
    return (
      <div className="padding-left-15 padding-right-15">
        <Form.Group className='margin-bottom-15'>
          <Row>
            <Col sm={8} style={{ marginTop: 10 }}>
              {downloadSample}
            </Col>
          </Row>
        </Form.Group>
        <Form.Group className='margin-bottom-15'>
          <Row>
            <Col sm={10}>
              <FormControl
                type="text"
                name="file_upload"
                className="margin-bottom-10"
                value={this.props.fileName}
              />
            </Col>
            <Col sm={2}>
              <FileUpload
                labelName="参照"
                onChange={this.props.handleFileChange}
                fileName={this.state.fileName}
                accept=".zip"
              />
            </Col>
          </Row>
        </Form.Group>
        <Form.Group className='margin-bottom-15'>
          <Row>
            <Col sm={12} className="text-center">
              <Button
                variant="primary"
                onClick={this.openNewDialog.bind(this, MessageTemplate.MSG_UPLOAD, null)}
                disabled={!this.props.fileName}
              >
                アップロード
              </Button>
            </Col>
          </Row>
        </Form.Group>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onOk}
        />
      </div>
    );
  }
}

export default BatchImport;
